import { IS_POPUP_VAR } from "@pdfking/constants/settings"
import { VERSION } from "@pdfking/constants/settings"
import url_read_tracked from "@pdfking/workflow/utils/url_read_tracked"
import { url_query_encode } from "@pdfking/workflow/utils/urlutilities"
import merge from "rfuncs/functions/merge"
import object_map from "rfuncs/functions/object_map"
import { defineComponent } from "vue"

import searchselect from "./searchselect"

export default defineComponent({
  extends: searchselect,
  props: ["adminurl", "adminfilters"],
  data() {
    return {
      selection: object_map(
        i => i.id,
        i => this.add_url(i),
        this.value
      ),
      loading: false,
      search_results: {},
      hide_dropdown: true,
    }
  },
  computed: {
    results() {
      return this.search_results
    },
  },
  watch: {
    query(q) {
      this.search(q)
    },
  },
  methods: {
    add_url(i, score) {
      return merge(i, {
        url: this.adminurl + i.id + "/",
        score: score || 0,
      })
    },
    search(q) {
      if (q.length <= 1) {
        this.search_results = {}
      } else if (!this.loading) {
        this.loading = true
        url_read_tracked(
          this.adminurl +
            "autocomplete/" +
            "?" +
            [
              url_query_encode({ q, [IS_POPUP_VAR]: VERSION }),
              this.adminfilters || "",
            ].join("&"),
          {}
        )
          .then(r => r.json())
          .then(r => {
            this.loading = false
            this.search_results = merge(
              {
                [q]: {
                  id: q,
                  unicode: `<em>${q}</em>`,
                  score: 0,
                },
              },
              object_map(
                v => v.id,
                (v, i) => this.add_url(v, i + 1),
                r.objects
              )
            )
          })
      }
    },
  },
})
